import { useState, useContext, useEffect } from "preact/hooks";
import { createContext, Component } from "preact";

let SessionContext = createContext(null);

export { SessionContext };
